import React from "react";
import { ColorUtils } from './../../configurations';
function ColorBars() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="242"
            height="77"
            fill="none"
            viewBox="0 0 242 77"
        >
            <path fill={ColorUtils.Color.blue} d="M0 21.617h32.688v54.832H0V21.617z"></path>
            <path fill={ColorUtils.Color.blue} d="M70.121 49.56h32.689v26.994H70.121V49.56z"></path>
            <path fill={ColorUtils.Color.blue} d="M140.246 43.76h32.689v32.9h-32.689v-32.9z"></path>
            <path fill={ColorUtils.Color.blue} d="M209.312 0h32.689v76.449h-32.689V0z"></path>
        </svg>
    );
}

export default ColorBars;
